module.exports = __webpack_public_path__ + "img/area_16.7aaccfe0.svg";